/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  /* product-form.liquid */
function changeColor(variant_id, element){
  if(element.name =="option-0"){
    var divsToHide = document.getElementsByClassName("div_variant");

    for(var i = 0; i < divsToHide.length; i++){
      if (divsToHide[i]) {
        divsToHide[i].style.visibility = "hidden"; 
        divsToHide[i].style.display = "none";
      }
    }

    if (document.getElementById(variant_id)) {
      document.getElementById(variant_id).style.visibility ="visible";
      document.getElementById(variant_id).style.display = "block";
    }
  }
}

/* product-form.liquid */
/* unables add to cart button after first size selecting (click on size label) */
function updateAddToCartButton(isColorButtonClick) {
  const addToCartButton = document.querySelector(".ProductForm__AddToCart")
  if (isColorButtonClick) {
    addToCartButton.classList.add("ProductForm__AddToCart__Initial")
    addToCartButton.removeAttribute("data-action")
    addToCartButton.disabled = true

    const selectedSizeButton = document.querySelector(".SizeEdmmondList_Size input:checked")
    if (selectedSizeButton) {
      selectedSizeButton.checked = false
    }

    addToCartButton.innerHTML = window.languages.selectSize
    console.log(addToCartButton)
  } else {
    addToCartButton.classList.remove("ProductForm__AddToCart__Initial")
  }
}


document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(".ProductForm__AddToCart");
  const sizeInputs = document.querySelectorAll(".SizeEdmmondList_Size input");
  const allDisabled = Array.from(sizeInputs).every(input => input.disabled);
if (allDisabled) return;

const translations = {
  en: { add: "Add to Cart", select: "Select Size", preorder: "Pre Order", outofstock: "Out of Stock" },
  es: { add: "Añadir al carrito", select: "Selecciona talla", preorder: "Preorden", outofstock: "Agotado" },
  nl: { add: "Toevoegen aan winkelwagen", select: "Selecteer maat", preorder: "Pre-order", outofstock: "Uitverkocht" },
  fr: { add: "Ajouter au panier", select: "Sélectionner la taille", preorder: "Précommande", outofstock: "Rupture de stock" },
  de: { add: "In den Warenkorb", select: "Größe auswählen", preorder: "Vorbestellung", outofstock: "Ausverkauft" },
};

  const langAttr = document.body.getAttribute("data-language");
const lang = translations[langAttr] ? langAttr : "en";
const isPreOrder = addToCartButton.dataset.meta === "true";

  // Set initial button text
  // const allDisabled = Array.from(sizeInputs).every(input => input.disabled);
  const allOutOfStock = Array.from(sizeInputs).every(input => {
  return input.dataset.quantity === "0";
});

if (allOutOfStock) {
  addToCartButton.innerHTML = translations[lang].outofstock;
} else if (isPreOrder) {
  addToCartButton.innerHTML = translations[lang].preorder;
} else {
  addToCartButton.innerHTML = translations[lang].add;
}
// if (isPreOrder) {
//   addToCartButton.innerHTML = "Pre Order";
// } else {
//   addToCartButton.innerHTML = translations[lang].add;
// }

  // Inject overlay div after button
  const overlay = document.createElement("div");
  overlay.classList.add("AddToCartOverlay");
  overlay.style.position = "absolute";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.cursor = "pointer";
  overlay.style.background = "transparent";
  overlay.style.zIndex = "10";

  // Make parent relative so overlay positions correctly
  const parent = addToCartButton.parentElement;
  parent.style.position = "relative";
  parent.appendChild(overlay);

  // Handle overlay click
  overlay.addEventListener("click", (e) => {
    const sizeSelected = Array.from(sizeInputs).some(input => input.checked);

    if (!sizeSelected) {
      e.preventDefault();
      addToCartButton.innerHTML = translations[lang].select;
      // overlay remains
    } else {
      // size selected: remove overlay and trigger button click
      overlay.remove();
      addToCartButton.click();
    }
  });

  // Remove overlay when user selects a size
sizeInputs.forEach(input => {
  input.addEventListener("change", () => {
    if (overlay.parentElement) {
      overlay.remove();
    }

// setTimeout(() => {
//   const isPreOrder =
//     addToCartButton.getAttribute("data-meta") === "true";

//   addToCartButton.innerHTML = isPreOrder
//     ? "Pre Order"
//     : translations[lang].add;
// }, 100);
setTimeout(() => {
  // const allDisabled = Array.from(sizeInputs).every(input => input.disabled);
  const allOutOfStock = Array.from(sizeInputs).every(input => {
  return input.dataset.quantity === "0";
});
  const isPreOrder = addToCartButton.getAttribute("data-meta") === "true";

  if (allOutOfStock) {
    addToCartButton.innerHTML = translations[lang].outofstock;
  } else if (isPreOrder) {
    addToCartButton.innerHTML = translations[lang].preorder;
  } else {
    addToCartButton.innerHTML = translations[lang].add;
  }
}, 100);
  });
});
});